var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilename({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EBE4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6673 11.8911V15.3332C21.6673 15.7999 21.6673 16.0332 21.7581 16.2115C21.838 16.3683 21.9655 16.4958 22.1223 16.5757C22.3006 16.6665 22.5339 16.6665 23.0007 16.6665H26.4428M26.6673 18.3234V24.3332C26.6673 25.7333 26.6673 26.4334 26.3948 26.9681C26.1552 27.4386 25.7727 27.821 25.3023 28.0607C24.7675 28.3332 24.0674 28.3332 22.6673 28.3332H17.334C15.9339 28.3332 15.2338 28.3332 14.699 28.0607C14.2286 27.821 13.8462 27.4386 13.6065 26.9681C13.334 26.4334 13.334 25.7333 13.334 24.3332V15.6665C13.334 14.2664 13.334 13.5663 13.6065 13.0315C13.8462 12.5611 14.2286 12.1787 14.699 11.939C15.2338 11.6665 15.9339 11.6665 17.334 11.6665H20.0105C20.6219 11.6665 20.9277 11.6665 21.2154 11.7356C21.4705 11.7968 21.7143 11.8978 21.938 12.0349C22.1903 12.1895 22.4065 12.4057 22.8389 12.8381L25.4957 15.4949C25.9281 15.9273 26.1443 16.1435 26.2989 16.3958C26.436 16.6195 26.537 16.8633 26.5982 17.1184C26.6673 17.4061 26.6673 17.7119 26.6673 18.3234Z",
    stroke: "#7D14FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilename);
export default __webpack_public_path__ + "static/media/filename.546c1400aded28f83c630dcf3a446182.svg";
export { ForwardRef as ReactComponent };